var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFD24F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4414 6L16.4414 8.4",
    stroke: "#013590",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5488 7.62646L21.2029 9.61357",
    stroke: "#013590",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.51221L11.264 9.55239",
    stroke: "#013590",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 11C13.5559 11 11 13.028 11 15.8975C11 17.732 11.7096 18.8674 12.391 19.8196C13.0723 20.7719 13.704 21.5328 13.704 22.7081V25.173C13.704 25.7576 14.1933 26.2 14.744 26.2H17.656C18.2067 26.2 18.696 25.7576 18.696 25.173V22.7081C18.696 21.5328 19.3277 20.7717 20.009 19.8196C20.6904 18.8675 21.4 17.7322 21.4 15.8975C21.4 13.0279 18.8441 11 16.2 11ZM16.2 11.4108C18.6291 11.4108 20.984 13.2696 20.984 15.8974C20.984 17.6295 20.3417 18.6447 19.6709 19.5819C19.0356 20.4698 18.3563 21.2944 18.2865 22.5025H14.1135C14.0437 21.2944 13.3644 20.4698 12.7291 19.5819C12.0582 18.6447 11.4159 17.6295 11.4159 15.8974C11.4159 13.2694 13.7709 11.4108 16.2 11.4108ZM14.12 22.9135H18.28V24.146H14.12V22.9135ZM14.12 24.5568H18.28V25.173C18.28 25.5325 17.9831 25.7893 17.656 25.7893H14.744C14.4169 25.7893 14.12 25.5325 14.12 25.173V24.5568Z",
    fill: "#013590",
    stroke: "#013590",
    strokeWidth: 0.75
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.7184d65ebc4bb81890a5f3d79d638142.svg";
export { ForwardRef as ReactComponent };